module.exports = {"initialValues":{"equipmentValue":"70.000","optionalEquipValue":[{"key":"70.000","value":"Under 70.000 kr."},{"key":"90.000","value":"70-90.000 kr."},{"key":"110.000","value":"90-110.000 kr."},{"_delete":true},{"_delete":true}]},"stepComponents":{"priceLoader":{"component":{"props":[{"loadText":[{},{},{},{},{"text":"${step-price-loader-customize-cu}","conditions":["1 == 1"]}]}]}}}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/packages/car/cu/package.car-fdm.json
// module id = 703
// module chunks = 0